export const BurgerMenuIcon = () => (
  <svg width="50px" height="50px" viewBox="0 0 24 24" fill="current" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 18L20 18" stroke="current" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M4 12L20 12" stroke="current" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M4 6L20 6" stroke="current" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
)